/** @jsxImportSource @emotion/react */
import { integrationDocumentation } from 'pages/Docs/components/documentation';

export const Integration = () => {
  return (
    <>
      {integrationDocumentation.map((doc) => (
        <div id={doc.id} key={doc.id}>
          {doc.content}
        </div>
      ))}
    </>
  );
};
